import { BydAlertDataInterface } from '../interface/byd-alert-data.interface';

export class BydAlertData {
  /**
   *
   */
  text: string;

  /**
   *
   */
  type: 'error' | 'success';

  /**
   * Max caracter.
   */
  maxCaracter = 10000;

  /**
   * Second action icon.
   */
  secondActionIcon?: string;

  /**
   * Disable close.
   */
  disableClose?: boolean;

  /**
   * @param data the alert data object
   */
  constructor(data: BydAlertDataInterface) {
    this.text = data.text;
    this.type = data.type;
    this.maxCaracter = data.maxCaracter || this.maxCaracter;
    this.secondActionIcon = data.secondActionIcon;
    this.disableClose = data.disableClose;
  }
}
